
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/subsets/icdot-subsets",
      function () {
        return require("private-next-pages/subsets/icdot-subsets.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/subsets/icdot-subsets"])
      });
    }
  